import { TikTokEmbed } from "react-social-media-embed"

export const EditableTikTok = ({ videoId, username, isEditing }) => {

  if (isEditing) {
    return (
      <div style={{
        width: 325,
        height: 575,
        pointerEvents: "none"
      }}>
        <iframe
          src={`https://www.tiktok.com/embed/v2/${videoId}`}
          width="325"
          height="575"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    )
  }

  return (
    <TikTokEmbed
      url={`https://www.tiktok.com/@${username}/video/${videoId}`}
      width={325}
    />
  )
}